(() => {
  const ready = async () => {
    const tasks = [], backgrounds = new Set();
    if (document.fonts) tasks.push(document.fonts.load('400 16px CosmoInter'),document.fonts.load('700 32px "Clash Display"'));
    const visible = el => {const b=el.getBoundingClientRect();return b.width>0&&b.height>0&&b.top<innerHeight&&b.bottom>0&&getComputedStyle(el).display!=='none';};
    document.querySelectorAll('img').forEach(img => {
      if (!visible(img)) return;
      img.loading='eager'; img.fetchPriority='high';
      if (img.decode) tasks.push(img.decode().catch(()=>{}));
    });
    document.querySelectorAll('.cv10__heroImg,.divine-store-backdrop,.divine-auth-art,.cosmo-header,.divine-commerce-hero,[data-critical-background]').forEach(el => {
      if (!visible(el)) return;
      for (const match of getComputedStyle(el).backgroundImage.matchAll(/url\(["']?([^"')]+)["']?\)/g)) backgrounds.add(match[1]);
    });
    backgrounds.forEach(src => {const image=new Image();image.fetchPriority='high';image.src=src;tasks.push(image.decode().catch(()=>{}));});
    await Promise.allSettled(tasks);
    requestAnimationFrame(() => {clearTimeout(window.divineLoadDeadline);window.divineReveal?.();});
  };
  if (document.readyState==='loading') document.addEventListener('DOMContentLoaded',ready,{once:true}); else ready();
})();
